import { iconsMap } from "./icons";

const Icon = ({ name, size = 16, color = "currentColor" }) => {
  const p = {
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: color,
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
  };

  const SvgIcon = iconsMap[name] || iconsMap["default"];
  return SvgIcon ? SvgIcon(p) : null;
};

export default Icon;